import * as React from 'react'

const SvgBannerEditIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.5 13.125h-5V2.5h11.25v5H15v-5c0-.69-.56-1.25-1.25-1.25H2.5c-.69 0-1.25.56-1.25 1.25v10.625c0 .69.56 1.25 1.25 1.25h5v-1.25zM4 4h6.25v1.25H4V4zm0 2.5h6.25v1.25H4V6.5zM4 9h3.75v1.25H4V9zm7.699 8.2l6.194-5.506a.889.889 0 00.307-.664.89.89 0 00-.307-.664l-1.465-1.302a1.073 1.073 0 00-.712-.264c-.263 0-.52.093-.712.264L8.8 14.579V17.2h2.899zm3.089-6.383l.926-.823 1.168 1.038-.926.823-1.168-1.038zm-4.77 5.256v-1.016l3.892-3.46 1.168 1.039-3.867 3.437h-1.193z"
      fill="#163250"
    />
  </svg>
)

export default SvgBannerEditIcon
